import React, { useEffect } from 'react'

type ExternalRedirectProps = {
  to: string
}

const ExternalRedirect = ({ to }: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return null
}

ExternalRedirect.displayName = 'ExternalRedirect'

export default ExternalRedirect
